import { useState } from 'react';
import { dossierAPI } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';

/**
 * "Maak leeg" bij De Lock — alleen voor beheerders, bedoeld om een fase in een testsessie
 * opnieuw te kunnen vullen. Raakt uitsluitend deze ene fase van DIT project: de aanroep gaat naar
 * het dossier van dit projectId. De inhoud van die sectie wordt vervangen door een lege inhoud;
 * eerder gevalideerde versies blijven in de historie van het dossier staan.
 * Een gevalideerde (gelockte) fase kan niet worden leeggemaakt: die moet eerst heropend.
 */
export function useSectionClear(
  projectId: string,
  projectNaam: string,
  fase: string,
  faseLabel: string,
  leegContent: Record<string, unknown>,
  herladen: () => void | Promise<void>,
) {
  const { isAdmin } = useAuth();
  const toast = useToast();
  const [clearing, setClearing] = useState(false);

  const doClear = async () => {
    const zeker = window.confirm(
      `Alles in "${faseLabel}" leegmaken voor het project "${projectNaam}"?\n\n`
      + 'De ingevulde inhoud van deze fase verdwijnt en je begint opnieuw. Alleen dit project wordt geraakt; '
      + 'eerder gevalideerde versies blijven in de historie van het dossier staan.'
    );
    if (!zeker) return;
    setClearing(true);
    try {
      await dossierAPI.saveSection(projectId, fase, leegContent);
      await herladen();
      toast.success('Leeggemaakt', `${faseLabel} van "${projectNaam}" staat weer leeg; je kunt opnieuw invullen.`);
    } catch (e: any) {
      toast.error('Leegmaken mislukt', e?.response?.data?.error || 'Probeer het opnieuw.');
    } finally {
      setClearing(false);
    }
  };

  return { canClear: isAdmin, clearing, doClear };
}
